module.exports = __webpack_public_path__ + "img/logo-auth.081beb7c.svg";